import APIServiceLookUp from './serviceAPI';
import { API_URL, MAIN_API_URL } from './models/AppConstent';

export default class ServiceOverview {
    lookupService = new APIServiceLookUp();

    async getCashCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getCashCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getInvoiceCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getInvoiceCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getOrderCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getOrderCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getNCCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getNCCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getCharData(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getCharData`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getTransactionChartData(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getTransactionChartData`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getTopOrder(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getTopOrder`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getTopItem(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getTopItem`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getTopCategory(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getTopCategory`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getBookingCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getBookingCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getHostelBookingCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getHostelBookingCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAttandanceCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getAttandanceCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getBookingCashCount(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getBookingCashCount`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getTopBooking(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getTopBooking`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getChartBookingData(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getChartBookingData`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getChartHBookingData(body, token) {
        var serviceType = "POST";
        var url = `${MAIN_API_URL}overview/getChartHBookingData`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}